import { ServiceType } from "@/generated/graphql_billing";

export enum Env {
  Develop = "develop",
  Test = "stg",
  Prod = "prod",
}

/**
 * @description BankCode
 * The values are generated by `scripts/list-clients.sh`.
 */
export enum BankCode {
  MFBank = "9999",
  Kyoshin = "1610",
  ShikokuBank = "0175",
  KyotoBank = "0158",
  Chugin = "0168",
  TochigiBank = "0517",
  DHBK = "0140",
  Aioinissaydowa = "9859",
  Yokoshin = "1280",
  FukuokaBank = "0177",
  KumamotoBank = "0587",
  ShinwaBank18 = "0181",
  ChibakogyoBank = "0135",
  Tokugin = "0572",
  GunmaBank = "0128",
  Bank82 = "0143",
  Hirogin = "0169",
  Joyobank = "0130",
  ShizuokaBank = "0149",
  NaganoBank = "0533",
  FirstBank = "0534",
  Demobank1 = "0000",
  IyoBank = "0174",
  Tamashin = "1360",
  NcBank = "0190",
  OkinawaBank = "0188",
  NantoBank = "0162",
  Miyagin = "0184",
  Ryugin = "0187",
  YamagataBank = "0122",
  MF2Bank = "9901",
  AkitaBank = "0119",
  AichiBank = "0542",
  Kitagin = "0509",
  MusashinoBank = "0133",
  Shigagin = "0157",
  FukuiBank = "0147",
  HokkaidoSk = "1001",
  Bank77 = "0125",
  Chitashin = "1556",
  KPMG = "9951",
  JPBank = "9900",
  Nangin = "0594",
}

export enum ServiceCode {
  BFM = "BFM",
  DXF = "DXF",
  Invoice = "INVOICE",
  Loan = "LOAN",
}

export const fmtServiceCode = (svc: ServiceCode | string): string => {
  switch (svc) {
    case ServiceCode.BFM:
      return "Mikatano 資金管理";
    case ServiceCode.DXF:
      return "Mikatano ワークス";
    case ServiceCode.Invoice:
      return "Mikatano インボイス管理";
    case ServiceCode.Loan:
      return "Mikatano 融資ポータル";
    default:
      console.error(`unknown service: ${svc}`);
      return "Mikatano サービス";
  }
};

// Deprecated: moved to config.ts
export const DEFAULT_COLOR = "#00c1ff";

/**
 * 業種が銀行業以外の場合に登録する支店コード
 */
export const DUMMY_BRANCH_OFFICE_CODE = "001";

// TODO: 本番リリース時は日付を変更する
export const BILLING_RENEWAL_DATE = new Date("2023-06-01T00:00:00+09:00");

export const COMPANY_OPTIONS_SETTLEMENT_MONTHS: {
  label: string;
  value: string;
}[] = [
  { label: "1", value: "01" },
  { label: "2", value: "02" },
  { label: "3", value: "03" },
  { label: "4", value: "04" },
  { label: "5", value: "05" },
  { label: "6", value: "06" },
  { label: "7", value: "07" },
  { label: "8", value: "08" },
  { label: "9", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
];

export const COMPANY_OPTIONS_PREFECTURES: { label: string; value: string }[] = [
  { label: "北海道", value: "01" },
  { label: "青森県", value: "02" },
  { label: "岩手県", value: "03" },
  { label: "宮城県", value: "04" },
  { label: "秋田県", value: "05" },
  { label: "山形県", value: "06" },
  { label: "福島県", value: "07" },
  { label: "茨城県", value: "08" },
  { label: "栃木県", value: "09" },
  { label: "群馬県", value: "10" },
  { label: "埼玉県", value: "11" },
  { label: "千葉県", value: "12" },
  { label: "東京都", value: "13" },
  { label: "神奈川県", value: "14" },
  { label: "新潟県", value: "15" },
  { label: "富山県", value: "16" },
  { label: "石川県", value: "17" },
  { label: "福井県", value: "18" },
  { label: "山梨県", value: "19" },
  { label: "長野県", value: "20" },
  { label: "岐阜県", value: "21" },
  { label: "静岡県", value: "22" },
  { label: "愛知県", value: "23" },
  { label: "三重県", value: "24" },
  { label: "滋賀県", value: "25" },
  { label: "京都府", value: "26" },
  { label: "大阪府", value: "27" },
  { label: "兵庫県", value: "28" },
  { label: "奈良県", value: "29" },
  { label: "和歌山県", value: "30" },
  { label: "鳥取県", value: "31" },
  { label: "島根県", value: "32" },
  { label: "岡山県", value: "33" },
  { label: "広島県", value: "34" },
  { label: "山口県", value: "35" },
  { label: "徳島県", value: "36" },
  { label: "香川県", value: "37" },
  { label: "愛媛県", value: "38" },
  { label: "高知県", value: "39" },
  { label: "福岡県", value: "40" },
  { label: "佐賀県", value: "41" },
  { label: "長崎県", value: "42" },
  { label: "熊本県", value: "43" },
  { label: "大分県", value: "44" },
  { label: "宮崎県", value: "45" },
  { label: "鹿児島県", value: "46" },
  { label: "沖縄県", value: "47" },
];

export const COMPANY_OPTIONS_STAFF_COUNTS: { label: string; value: string }[] =
  [
    { label: "1", value: "01" },
    { label: "2〜5", value: "02" },
    { label: "6〜10", value: "03" },
    { label: "11〜20", value: "04" },
    { label: "21〜30", value: "05" },
    { label: "31〜50", value: "06" },
    { label: "51〜100", value: "07" },
    { label: "101〜300", value: "08" },
    { label: "301〜", value: "09" },
  ];

export const COMPANY_OPTIONS_INDUSTRIES_CODE_LARGE: {
  label: string;
  value: string;
}[] = [
  { label: "農業，林業", value: "A" },
  { label: "漁業", value: "B" },
  { label: "鉱業、採石業、砂利採取業", value: "C" },
  { label: "建設業", value: "D" },
  { label: "製造業", value: "E" },
  { label: "電気、ガス、熱供給、水道業", value: "F" },
  { label: "情報通信業", value: "G" },
  { label: "運輸業、郵便業", value: "H" },
  { label: "卸売業、小売業", value: "I" },
  { label: "金融業・保険業", value: "J" },
  { label: "不動産業、物品賃貸業", value: "K" },
  { label: "学術研究、専門、技術サービス業", value: "L" },
  { label: "宿泊業、飲食サービス業", value: "M" },
  { label: "生活関連サービス業、娯楽業", value: "N" },
  { label: "教育、学習支援業", value: "O" },
  { label: "医療、福祉", value: "P" },
  { label: "複合サービス事業", value: "Q" },
  { label: "サービス業（他に分類されないもの）", value: "R" },
  { label: "公務", value: "S" },
  { label: "分類不能の産業", value: "T" },
];

export const COMPANY_OPTIONS_INDUSTRIES_CODE_MIDDLE_RAW: {
  [key: string]: { [key: string]: string };
} = {
  A: { "01": "農業", "02": "林業" },
  B: { "03": "漁業（水産養殖業を除く）", "04": "水産養殖業" },
  C: { "05": "鉱業、採石業、砂利採集業" },
  D: { "06": "総合工事業", "07": "職別工事業", "08": "設備工事業" },
  E: {
    "09": "食料品製造業",
    "10": "飲料・タバコ・飼料製造業",
    "11": "繊維製造業",
    "12": "木材・木製品製造業",
    "13": "家具・装飾品製造業",
    "14": "パルプ・紙・紙加工品製造業",
    "15": "印刷・同関連業",
    "16": "化学工業",
    "17": "石油製品・石炭製品製造業",
    "18": "プラスチック製品製造業（別掲を除く）",
    "19": "ゴム製品製造業",
    "20": "なめし革・同製品・毛皮製造業",
    "21": "窯業・土石製品製造業",
    "22": "鉄鋼業",
    "23": "非鉄金属製造業",
    "24": "金属製品製造業",
    "25": "汎用機械器具製造業",
    "26": "生産用機械器具製造業",
    "27": "業務用機械器具製造業",
    "28": "電子部品・デバイス・電子回路製造業",
    "29": "電気機械器具製造業",
    "30": "情報通信機械器具製造業",
    "31": "輸送用機械器具製造業",
    "32": "その他の製造業",
  },
  F: { "33": "電気業", "34": "ガス業", "35": "熱供給業", "36": "水道業" },
  G: {
    "37": "通信業",
    "38": "放送業",
    "39": "情報サービス業",
    "40": "インターネット付随サービス業",
    "41": "映像・音声・文字情報制作業",
  },
  H: {
    "42": "鉄道業",
    "43": "道路旅客運送業",
    "44": "道路貨物運送業",
    "45": "水運業",
    "46": "航空運輸業",
    "47": "倉庫業",
    "48": "運輸に附帯するサービス業",
    "49": "郵便業（信書便事業を含む）",
  },
  I: {
    "50": "各種商品卸売業",
    "51": "繊維・衣服等卸売業",
    "52": "飲食料品卸売業",
    "53": "建築材料，鉱物・金属材料等卸売業",
    "54": "機械器具卸売業",
    "55": "その他の卸売業",
    "56": "各種商品小売業",
    "57": "織物・衣服・身の回り品小売業",
    "58": "飲食料品小売業",
    "59": "機械器具小売業",
    "60": "その他の小売業",
    "61": "無店舗小売業",
  },
  J: {
    "62": "銀行業",
    "63": "協同組織金融業",
    "64": "貸金業，クレジットカード業等非預金信用機関",
    "65": "金融商品取引業，商品先物取引業",
    "66": "補助的金融業等",
    "67": "保険業（保険媒介代理業，保険サービス業を含む）",
  },
  K: { "68": "不動産業", "69": "不動産賃貸業・管理業", "70": "物品賃貸業" },
  L: {
    "71": "学術・開発研究機関",
    "72": "専門サービス業（他に分類されないもの）",
    "73": "広告業",
    "74": "技術サービス業（他に分類されないもの）",
  },
  M: { "75": "宿泊業", "76": "飲食店", "77": "持ち帰り・配達飲食サービス業" },
  N: {
    "78": "洗濯・理容・美容・浴場業",
    "79": "その他の生活関連サービス業",
    "80": "娯楽業",
  },
  O: { "81": "学校教育", "82": "その他の教育，学習支援業" },
  P: {
    "83": "医療業",
    "84": "保険衛生",
    "85": "社会保険・社会福祉・介護事業",
  },
  Q: { "86": "郵便局", "87": "協同組合（他に分類されないもの）" },
  R: {
    "88": "廃棄物処理業",
    "89": "自動車整備業",
    "90": "機械等修理業（別掲を除く）",
    "91": "職業紹介・労働者派遣業",
    "92": "その他の事業サービス業",
    "93": "政治・経済・文化団体",
    "94": "宗教",
    "95": "その他のサービス業",
    "96": "外国公務",
  },
  S: { "97": "国家公務", "98": "地方公務" },
  T: { "99": "分類不能の産業" },
};

export const FAQ_URL =
  "https://support.id.x.moneyforward.com/hc/ja/articles/16696873389465";

/**
 * The base URL host for LP (Landing Page) depending on the environment.
 * If the environment is "prod", the base URL host is "lp.x.moneyforward.com".
 * Otherwise, the base URL host is "lp.x.test.mfw.work".
 */
export const LP_URL_HOST_NAME_PROD = "lp.x.moneyforward.com";
export const LP_URL_HOST_NAME_NOT_PROD = "lp.x.test.mfw.work";

export const ServiceNames = {
  DXF: {
    LowerCase: "dxf",
    UpperCase: "DXF",
    CODE: "DXF",
    Type: ServiceType.Mikatano,
    NameJaJp: "ワークス",
  },
  BFM: {
    LowerCase: "bfm",
    UpperCase: "BFM",
    CODE: "BFM",
    Type: ServiceType.Mikatano,
  },
  Invoice: {
    LowerCase: "invoice",
    UpperCase: "INVOICE",
    CODE: "INVOICE",
    Type: ServiceType.Mikatano,
    NameJaJp: "インボイス管理",
  },
  Loan: {
    LowerCase: "loan",
    UpperCase: "LOAN",
    CODE: "LOAN",
    Type: ServiceType.Mikatano,
  },
  MfcInvoice: {
    LowerCase: "mfc-invoice",
    UpperCase: "MFC-INVOICE",
    CODE: "MFC_INVOICE",
    Type: ServiceType.Other,
    Annotation: `契約後にプロダクトキーを入力することで、マネーフォワード
    クラウド請求書の特定の機能を無料でご利用いただけます。`,
  },
  // DEPRECATED: please use libs/defs.tsx
  ExternalTroubleSupport: {
    LowerCase: "external-troublesupport",
    UpperCase: "EXTERNAL-TROUBLESUPPORT",
    CODE: "EXTERNAL_TROUBLESUPPORT",
    Type: ServiceType.Other,
    NameJaJp: "お困りごとサポートデスク",
    EssentialInfo: {
      PhoneNumber: "0570-003565",
    },
    Description: "パソコンやMikatanoに関する電話相談",
    Note: "※お問合せフォームご案内の場合もあり",
    Link: "https://mikatano-service.lp.x.moneyforward.com/techsd",
  },
  ExternalBusinessSupport: {
    LowerCase: "external-businesssupport",
    UpperCase: "EXTERNAL-BUSINESSSUPPORT",
    CODE: "EXTERNAL_BUSINESSSUPPORT",
    Type: ServiceType.Other,
    NameJaJp: "ビジネスサポートデスク",
    EssentialInfo: {
      PhoneNumber: "050-1754-0542",
    },
    Description: "売上増加を図る施策や補助金のご相談",
    Note: "※Mikatanoに関する相談は対象外です\n※外部サービスへ遷移します",
    Link: "https://mikatano-collabo.lp.x.moneyforward.com/bizsd_useful",
  },
  ExternalBenefitSelect: {
    LowerCase: "external-benefitselect",
    UpperCase: "EXTERNAL-BENEFITSELECT",
    CODE: "EXTERNAL_BENEFITSELECT",
    Type: ServiceType.Other,
    NameJaJp: "ベネフィットセレクト",
    Description: "日常生活の出費を補助する福利厚生",
    Link: "https://mikatano-collabo.lp.x.moneyforward.com/benefit",
    Annotation: `ベネフィットセレクトはプラン契約後、
    翌営業日を目処にご利用いただけます。`,
  },
} as const;

/**
 * @description APIContext はGraphQLをどのサーバーに対してリクエストするかを示すためのenumです。\
 * 例えば、BILLINGを指定すると、課金システムのGraphQLサーバーにリクエストを送信します。\
 * ## Known Issues
 * - そもそも、APIContextを設定し忘れた場合、デフォルトのIDサーバーにリクエストを送信してしまう。\
 * - 理想としては、各サーバーで定義されているGraphQLクエリを利用したならば、自動的にそのサーバーにリクエストを送信するようにしたい。
 * en) APIContext is an enum that indicates which server to send the GraphQL request to.
 * For example, if you specify BILLING, the request will be sent to the billing system's GraphQL server.
 * ## Known Issues
 * - If you forget to set APIContext, the request will be sent to the default ID server.
 * - Ideally, if you use a GraphQL query defined on each server, the request should be automatically sent to that server.
 */
export enum APIContext {
  BILLING = "billing",
}

/**
 * @description This object has the google form information for the collection of the reason for cancellation.
 */
export type CancelReasonGFormInfo = {
  PrefilledLink: string;
  DisplayIdParam: string;
};

export const CANCEL_REASON_GFORM_INFO_TEST: CancelReasonGFormInfo = {
  PrefilledLink:
    "https://docs.google.com/forms/d/e/1FAIpQLScWzT2Xjhgo8VeFkkVfe1C5XyLmCsmhftH-ccz_KSwpDygLIA/viewform?usp=pp_url",
  DisplayIdParam: "entry.1960651426",
};

/**
 * @description This object has the google form information for the collection of the reason for cancellation. (Production)
 * The original file is here.
 * !!!! THIS MUST BE KEPT IN SYNC WITH THE FOLLOWING GOOGLE SHEET !!!!
 * https://docs.google.com/spreadsheets/d/1qW-KHZHOVRxJ9YNwovW4jIEcy_ZCPta2ZrEg0OxFLjg/edit#gid=1050646083&range=A1
 */
export const CANCEL_REASON_GFORM_INFOS_PROD: {
  [key in BankCode]: CancelReasonGFormInfo;
} = {
  [BankCode.MFBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSek0CTgBggyIDi0W6z6DxEziwRYEJoMTXLRkshVtv_b3Ypd2Q/viewform?usp=pp_url",
    DisplayIdParam: "entry.744397820",
  },
  [BankCode.ShikokuBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScngg3DrAoM6KPxdAsy8BMehOt4WsLzQaz3P_lRoUXiD9W7yw/viewform?usp=pp_url",
    DisplayIdParam: "entry.1739243286",
  },
  [BankCode.Yokoshin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSf7oeK5T99T_FFEWhpgEmgTm_VaRLp_itDmGaHnpydetr5VJA/viewform?usp=pp_url",
    DisplayIdParam: "entry.505749336",
  },
  [BankCode.FukuokaBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSdSQC950AhJ8tqQL2CHIET-lvrzMlLbxZUAneU3JY4RZC6ZoQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.2083129335",
  },
  [BankCode.KumamotoBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSdm59nM2i6crQ06DhkSCo8tQboSw---V-wvcgfLXzAhNicvHg/viewform?usp=pp_url",
    DisplayIdParam: "entry.302128299",
  },
  [BankCode.ShinwaBank18]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSdeo8deLXyMttfcKOGnMfJltzlpHaijBbtc2Hoe_ZG29jRlFw/viewform?usp=pp_url",
    DisplayIdParam: "entry.1963343937",
  },
  [BankCode.ChibakogyoBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScFgqP5zu6mxuyIHSasFhfpEu5kMtPWPoJxHN-prW9gX44lAg/viewform?usp=pp_url",
    DisplayIdParam: "entry.1418187074",
  },
  [BankCode.Tokugin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSc_KORGVIvDBT9eCsKkh2Gvx4M2C5pWEDQA-4wq9efS1KW3Aw/viewform?usp=pp_url",
    DisplayIdParam: "entry.1923080118",
  },
  [BankCode.Chugin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeeoDtw18rQEfDsvXRtFdMPL2yxxuygK85M7hOSEEWI9eaBFQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.928670446",
  },
  [BankCode.TochigiBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeoTrb8REzzkKrbfrZkr_tSxJs2mFLE8iin0zfIZeP8Sw347g/viewform?usp=pp_url",
    DisplayIdParam: "entry.718137790",
  },
  [BankCode.GunmaBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScJ4CUO9TC7MpEQIqPw5XEtxZV4iSUZeIzLzAett4Omw5jKiA/viewform?usp=pp_url",
    DisplayIdParam: "entry.1457057598",
  },
  [BankCode.Bank82]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeXUJsoWFzBoBZTgnBs5QewnKgjrpHgNgH4bmI-3cTndts3QQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.100118332",
  },
  [BankCode.Hirogin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSd9yNQeD6P3Xa12I6rpVIjdGOSeHYR9ZSmjdnRvW1fH7JaQUQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.1373396957",
  },
  [BankCode.KyotoBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSfXYMJIy0TjupfUZbcvJDaWK_KCD4wMmG3PUv0CTnUspw8Icg/viewform?usp=pp_url",
    DisplayIdParam: "entry.139526668",
  },
  [BankCode.Joyobank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScHQpozllLKEUiE-T7kN7CS5-fsjNfHemWVKecRH3SkFaoUMA/viewform?usp=pp_url",
    DisplayIdParam: "entry.1957679982",
  },
  [BankCode.ShizuokaBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSdLnuJdrWevlBItx0dTyYbr57ZygIRF6FtLf4Q7IBL_EEsOKg/viewform?usp=pp_url",
    DisplayIdParam: "entry.1660945615",
  },
  [BankCode.NaganoBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSci4wEYnjQ4kIAWkD7IMMA6B8DRAzEN_uPlKiCQH-hMOFdY2A/viewform?usp=pp_url",
    DisplayIdParam: "entry.1603783858",
  },
  [BankCode.FirstBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScefnX1inWLzp3yZwlX_3RS9Aqv4eCmoiAiaYpsN3WNRBGUjg/viewform?usp=pp_url",
    DisplayIdParam: "entry.322275593",
  },
  [BankCode.Demobank1]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSe0KH37iFIpUnFXvBkS8zjfttnhli1APfl2mn0BK3HLLxoJ9w/viewform?usp=pp_url",
    DisplayIdParam: "entry.984725683",
  },
  [BankCode.IyoBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScJ6up-mVJCeIbLnbqmba-yxLIWnTO2AZ8pKSIkIfbNHb1yEQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.1897506602",
  },
  [BankCode.Tamashin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScYtsPuJ-FvWTto9MrMwNPI0bzg3h68nnlbzqcIoijbQghpKA/viewform?usp=pp_url",
    DisplayIdParam: "entry.157230351",
  },
  [BankCode.NcBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSftkd7ul2k3gfJZVYfaMwWguHRmVJ5BRRkNE5o8KFdYDxbh_g/viewform?usp=pp_url",
    DisplayIdParam: "entry.1646073404",
  },
  [BankCode.OkinawaBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSfDQpkM9r2h4HgiU2tuWh32VJY0croduXdBjoZCNRoffkcXQw/viewform?usp=pp_url",
    DisplayIdParam: "entry.972359068",
  },
  [BankCode.Kyoshin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeTn7InIZkO7CGYsgotzZHQrdYXeZSv_iBLrGARHugJxX6qQw/viewform?usp=pp_url",
    DisplayIdParam: "entry.1074727276",
  },
  [BankCode.NantoBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeNuambycKjTvbiRnu-G15H9Qh1FTtFx2uSoRaLb6AgsrZeEw/viewform?usp=pp_url",
    DisplayIdParam: "entry.745060463",
  },
  [BankCode.Miyagin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSe7tIi92vyEO3cEc22A8-pPqMO1ss81HlK0qVhqV0fFvc8-Zw/viewform?usp=pp_url",
    DisplayIdParam: "entry.1987495232",
  },
  [BankCode.Ryugin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSfH8Li8BeV65zIm306k5Yn5GYHr0ArWzDqihZdSLlAvAjHebQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.497351015",
  },
  [BankCode.YamagataBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeqgJBiJMSG41R2iFofhYuuZLA-Uej5kmsXWMaWhFcbUDoLDQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.704258033",
  },
  [BankCode.MF2Bank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSe9FZyAwMa9peZxdjG46ewE5C8Ns6UY_zlFUpKKOk0u5GguSQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.396714604",
  },
  [BankCode.DHBK]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSfRZMJUxqbtnUlmnat5qFoesUlZAl_To_gTsagGjHNT3npZFA/viewform?usp=pp_url",
    DisplayIdParam: "entry.1101097680",
  },
  [BankCode.AkitaBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSflfuG9Hjw9pUkIDJdjVmW_bbmNwV8ZdpQ0a9cNuo_mrFPpTg/viewform?usp=pp_url",
    DisplayIdParam: "entry.1837723862",
  },
  [BankCode.AichiBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeobQalkss7ECW6G1qhklaJRI57xc7Iw2cEt-VSlu3tbDya-w/viewform?usp=pp_url",
    DisplayIdParam: "entry.1817051189",
  },
  [BankCode.Kitagin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSfu3_810W4oyLZpHI0VIhFOI88v0P0BbG1qVQC0E_d8qTuUIQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.790747045",
  },
  [BankCode.MusashinoBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSf4Z0B6Msafx9BSGFeEPRmRcr8kT1jhbl6uH4sAFQUWjNTurw/viewform?usp=pp_url",
    DisplayIdParam: "entry.2144865921",
  },
  [BankCode.Shigagin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeGoiwRFCmRn6fTTFfxpU80aQDv6yBfr2UIZJvM9YYCNCPDzw/viewform?usp=pp_url",
    DisplayIdParam: "entry.1073171406",
  },
  [BankCode.FukuiBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScBhM3xgH5lhuBXbS_yh2HaLxzHgX2UX9Zz2uYa9_DlfSs5PA/viewform?usp=pp_url",
    DisplayIdParam: "entry.273580339",
  },
  [BankCode.HokkaidoSk]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSenxXO-x8YyqkU5SOj7j8jPmeu5Nq8kntRYYOTo-MOkoYZmXg/viewform?usp=pp_url",
    DisplayIdParam: "entry.280475676",
  },
  [BankCode.Bank77]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSdpWrf1qlTQp0jDJrEUz4EtzRAkNfy_nQJ5-Vb2lsV4FxMjZA/viewform?usp=pp_url",
    DisplayIdParam: "entry.1392233909",
  },
  [BankCode.Chitashin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSdhBBdd_ejwUrM2-3OevIcUSxoQy_dPMYhgB8Dys2V26nFOOw/viewform?usp=pp_url",
    DisplayIdParam: "entry.1065464053",
  },
  [BankCode.Aioinissaydowa]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSfhgRxygTmqT6c1ONQpIsuikkEzkrUaUthvJxpcfOhSSIJOGQ/viewform?usp=pp_url",
    DisplayIdParam: "entry.911238251",
  },
  [BankCode.KPMG]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeR_vBRCBqa1JFHzktVUlq_Ep52LjRw3tL0IwLZbMjZXYlNXg/viewform?usp=pp_url",
    DisplayIdParam: "entry.1960651426",
  },
  [BankCode.JPBank]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLScZM0Jty6e2sLYCqSWnsp9PocZJexixd5qEjPHGa3bz1lGvaA/viewform?usp=pp_url",
    DisplayIdParam: "entry.1960651426",
  },
  [BankCode.Nangin]: {
    PrefilledLink:
      "https://docs.google.com/forms/d/e/1FAIpQLSc2OLuvp0injU6ia97x3dzwwUkIxRBNGjsoR9QrepeJ4yCoAw/viewform?usp=pp_url",
    DisplayIdParam: "entry.1960651426",
  },
};

export const URLMFAggreTerms =
  // アグリゲーション機能利用規約
  "https://moneyforward-x.co.jp/mfw/agfunc_terms/";
export const URLMFAggreThirdPartyDataProvisionTerms =
  // アグリゲーション機能における利用者情報の第三者提供に関する特約
  "https://moneyforward-x.co.jp/mfw/agfunc_tpp/";
export const URLMFPrivacyPolicyTreatment =
  // 個人情報の取扱について
  "https://corp.moneyforward.com/privacy/#treatment";
export const URLMFAPIAgreement =
  // 電子決済等代行業に関する表示等
  "https://corp.moneyforward.com/api_agreement/#api";

export const URLMFXIDTerms =
  // Mikatano ID 利用規約
  "/terms/id";
export const URLMFXTermsOfService =
  // 指定サービスに関する特約
  "/terms/service";
export const URLMFXDataProvisionPolicy =
  // 利用者情報の第三者提供に関する特約
  "/terms/policy_data_provision";
export const URLMFXPrivacyPolicy =
  // 個人情報保護方針
  "https://moneyforward-x.co.jp/privacy/";
export const URLMFXPrivacyPolicyTreatment =
  // 個人情報の取扱について
  "https://moneyforward-x.co.jp/privacy/#treatment";
export const URLMFXExternalToolsPrivacyPolicy =
  // 外部送信ツールについて
  "https://moneyforward-x.co.jp/external-tools/";

export enum ExternalIDPName {
  Bizsol = "bizsol",
  ConnectBoard = "connectBoard",
}
